import React, { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useMediaQuery} from '@mui/material';
import { styled } from '@mui/material/styles';
import SectionLayout from '../../shared/layout/SectionLayout';

const BoxRoot = styled('div')(({ theme, ...props }) => ({
  position:'relative',
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  width: props.bannerStyle === 'boxed' && props.page === 'home' ? "90%" : "100%" ,
  height: (props.bannerPcMaxHeight ? `${props.bannerPcMaxHeight}px` : props.height ? props.height : 'auto'),
  maxHeight: (props.bannerPcMaxHeight ? `${props.bannerPcMaxHeight}px` : props.height ? props.height : 'auto'),
  borderRadius: props.bannerStyle === 'fullWidth' ? '0px' : '20px',
  ...(props.bannerPaddingTop ? {...{paddingTop:`${props.bannerPaddingTop}px`}} : {}),
  ...(props.bannerPaddingBottom ? {...{paddingBottom:`${props.bannerPaddingBottom}px`}} : {}),
  overflow:'hidden',
  '&::before':{
    content: "''",
    position: "absolute",
    width: "100%",
    height: (props.bannerPcMaxHeight ? `${props.bannerPcMaxHeight}px` : props.height ? props.height : 'auto'),
    maxHeight: (props.bannerPcMaxHeight ? `${props.bannerPcMaxHeight}px` : props.height ? props.height : 'auto'),
    ...(props.flipBannerImage ? {...{transform: props.isRTL === 'en' ? 'scaleX(1)' : 'scaleX(-1)'}} : {}),
    backgroundImage: props.customGradient ? `linear-gradient(180deg, #09255500, #05122B), url(${props.image})` : `linear-gradient(to right, ${props.transparencyColor}, ${props.transparencyColor}), url(${props.image})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: 'center center',
    ...(props.bannerPaddingTop ? {...{paddingTop:`${props.bannerPaddingTop}px`}} : {}),
    ...(props.bannerPaddingBottom ? {...{paddingBottom:`${props.bannerPaddingBottom}px`}} : {}),
  },
  marginTop: props.displayMenuOverHeader ? '0px' : '99px',
  ...(props.bannerStyle === 'boxed' && props.page === 'home' ? {marginLeft:'auto',marginRight:'auto'} : {}),
  '@media (max-width: 992px)': {
    width:'100%',
    borderRadius:'0px',
    '&::before':{
      height: props.mbHeight || '600px',
      maxHeight: props.mbHeight || '600px',
    },
    height: props.mbHeight || '600px',
    maxHeight: props.mbHeight || '600px',
  }
}));

const useStyles = makeStyles(theme => ({
  insideCont:{
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    height:'100%'
  }
}));

const Header = (props) => {
  const [viewportWidth, setViewportWidth] = React.useState(window.innerWidth);
  const { image, height, mbHeight, children, transparencyColor, displayBanner,bannerStyle,data, page,matches, customGradient,customStyle, onClickEvent } = props;
  const { bannerSubTitle,bannerFontColor, bannerTitleDirection, bannerSpaceBetween, bannerImage, bannerImageSize, bannerPaddingBottom, bannerPaddingTop, bannerMaxHeight, bannerAlignment, bannerMobileHeight, displayMenuOverHeader, flipBannerImage, templateLang, isRTL, bannerPcMaxHeight,bannerMobileMaxHeight } = data || {};
  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const matches720 = useMediaQuery('(min-width:992px)');
  const classes = useStyles({flipBannerImage,templateLang,isRTL,bannerStyle,transparencyColor,image,bannerMaxHeight,bannerMaxHeight, bannerMobileHeight, page,matches,displayMenuOverHeader,bannerPaddingTop,customGradient,bannerPcMaxHeight,bannerMobileMaxHeight, bannerPaddingBottom, mbHeight,viewportWidth,...props});
  if(displayBanner) 
  return (
    <BoxRoot
      {...(onClickEvent ? {onClick: onClickEvent} : {})}
      style={matches ? {marginTop: displayMenuOverHeader ? '0px' : '78px',...customStyle} : {...customStyle}}
      {...{
        flipBannerImage,templateLang,isRTL,bannerStyle,transparencyColor,image,bannerMaxHeight,bannerMaxHeight, bannerMobileHeight, page,matches,displayMenuOverHeader,bannerPaddingTop,customGradient,bannerPcMaxHeight,bannerMobileMaxHeight, bannerPaddingBottom, mbHeight,viewportWidth,...props
      }}
      >
      <SectionLayout
      style={{position:'relative',height:'100%'}} disableTopPadding disableBottomPadding
      >
        {props.page === 'home' ?
          children
        :
        <div className={classes.insideCont}>
          {children}
        </div>
        }
      </SectionLayout>
    </BoxRoot>
  );

  return null;
};

export default Header;